import { RadixDialog } from '@/components/RadixDialog';
import type { DelayTime } from '@/constants';
import { useGlobalState, usePreventBodyScroll } from '@/hooks';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { TrackingOnboardingPopupWrapper } from './TwoPanelCenter.styles';
import { TrackingLeftPanel } from './components/TrackingLeftPanel';
import { TrackingRightPanel } from './components/TrackingRightPanel';

export const TwoPanelCenter: React.FC<
  // onCloseOnboardingPopUp and onboardingPopUpDelayTime should be passed as props instead of getting from Popup context
  // since this component is also used in Account page which is not a part of PMT and cannot get value from Popup context (PopupContext is belong to PMT)
  IPmtOnboardingPopup & { onCloseOnboardingPopUp: () => void; onboardingPopUpDelayTime?: DelayTime }
> = ({
  joinUsHeader,
  joinUsValuePropositionList,
  onCloseOnboardingPopUp,
  onboardingPopUpDelayTime,
  ...rightPanelProps
}) => {
  const { showPMTPopUp } = useGlobalState();

  usePreventBodyScroll(showPMTPopUp);

  return (
    <RadixDialog open={showPMTPopUp} onOpenChange={onCloseOnboardingPopUp}>
      <TrackingOnboardingPopupWrapper>
        <TrackingLeftPanel joinUsHeader={joinUsHeader} joinUsValuePropositionList={joinUsValuePropositionList} />
        <TrackingRightPanel
          {...rightPanelProps}
          delayTime={onboardingPopUpDelayTime}
          onClose={onCloseOnboardingPopUp}
        />
      </TrackingOnboardingPopupWrapper>
    </RadixDialog>
  );
};
